import { LandingSectionTitle } from '@features/landing/shared/ui/components/LandingSectionTitle';
import styles from './ParticipationChecklist.module.css';
import { LINK_TOURNAMENTS } from '@features/chessrussian/customizations/constants';
import { ZoomIcon } from '@features/landing/shared/ui/icons/ZoomIcon';
import { ParticipationInfo } from '@features/landing/shared/ui/components/ParticipationInfo';
import { StepsList } from '@features/landing/shared/ui/components/StepsList';
import { LandingLink } from '@features/landing/shared/ui/components/LandingLink/LandingLink';
import { MobileBr } from '@features/landing/shared/ui/components/Br/Br';

export function ParticipationChecklist() {
  return (
    <>
      <LandingSectionTitle>Как принять участие</LandingSectionTitle>

      <StepsList>
        <>
          Войдите в свой аккаунт ChessOpen
          <MobileBr /> и вступите{' '}
          <LandingLink chevron href={LINK_TOURNAMENTS}>
            в&nbsp;клуб&nbsp;РШШ
          </LandingLink>
        </>
        <>
          <LandingLink chevron href="#prices">
            Оплатите премиум-аккаунт
          </LandingLink>
          <MobileBr /> на&nbsp;удобных условиях
        </>
        <>
          <LandingLink chevron href={LINK_TOURNAMENTS}>
            Выберите подходящий турнир
          </LandingLink>
          <MobileBr /> и&nbsp;станьте его участником
        </>
      </StepsList>

      <ParticipationInfo icon={<ZoomIcon className={styles.zoomIcon} />}>
        Для участия в турнире обязательно понадобится веб-камера или мобильный
        телефон и приложение Zoom. Они должны работать во время игры, чтобы
        мы&nbsp;могли убедиться, что участнику никто&nbsp;не&nbsp;помогает.
      </ParticipationInfo>
    </>
  );
}
